import dialog from "@/presets/lara/dialog";
import dropdown from "@/presets/lara/dropdown";
import radiobutton from "@/presets/lara/radiobutton";

export const dialogPt = {
  ...dialog,
  root: (options: { state: Record<string, unknown> }) => ({
    class: [dialog.root(options).class, "flex flex-col"],
  }),
  header: {
    class: "!p-0 !bg-white !rounded-t-lg",
  },
  content: () => ({
    class: "!p-0 !bg-white overflow-y-auto min-h-0",
  }),
  footer: {
    class: "!p-0 !bg-white !rounded-b-lg shrink-0",
  },
  mask: () => ({
    class:
      "transition-all duration-300 !bg-gray-900/80 !backdrop-blur !flex-col !items-center !justify-start !overflow-y-auto before:content-[''] before:block before:h-8 before:shrink-0 after:content-[''] after:block after:h-8 after:shrink-0",
  }),
};

export const dropdownPt = {
  dropdown,
  root: ({ props, state }) => {
    const rootClasses = dropdown.root({ props, state });
    return {
      class: [rootClasses.class, { "ring-0 border-black": state.focused }],
    };
  },
  header: {
    class: [dropdown.header.class, "border-b-0"],
  },
  panel: {
    class: [dropdown.panel.class, "bg-white w-full shadow-md"],
  },
  filterinput: {
    class: [dropdown.filterinput.class, "border-gray-400 shadow-xs focus:ring-0 focus:border-black"],
  },
  filtericon: {
    class: [dropdown.filtericon.class, "stroke-gray-400"],
  },
  item: ({ context }) => {
    const itemClasses = dropdown.item({ context });
    return {
      class: [itemClasses.class, "!py-0 px-0"],
    };
  },
};

export const radioButtonPt = {
  ...radiobutton,
  root: ({ props }) => ({
    class: [radiobutton.root.class, { "!cursor-default": props.disabled }],
  }),
  input: ({ props }) => ({
    class: [radiobutton.input.class, { "!cursor-default": props.disabled }],
  }),
  box: ({ props }) => {
    return {
      class: [
        // Flexbox
        "flex justify-center items-center",

        // Size
        "w-[1.571rem] h-[1.571rem]",

        // Shape
        "border-2",
        "rounded-full",
        "border-indigo-base",

        // Transition
        "transition duration-200 ease-in-out",

        // Colors
        {
          "text-surface-700 dark:text-white/80": props.value !== props.modelValue && props.value !== undefined,
          "bg-surface-0 dark:bg-surface-900": props.value !== props.modelValue && props.value !== undefined,
        },
        // Invalid State
        { "border-red-500 dark:border-red-400": props.invalid },

        // States
        {
          "peer-focus-visible:ring-2 peer-focus-visible:ring-indigo-base/20": !props.disabled,
          "opacity-60 cursor-default": props.disabled,
        },
      ],
    };
  },
  icon: ({ props }) => {
    return {
      class: [
        "block",

        // Shape
        "rounded-full",

        // Size
        "w-3 h-3",

        // Colors
        "bg-indigo-base",

        // Conditions
        {
          "backface-hidden scale-10 invisible": props.value !== props.modelValue,
          "transform visible scale-[1.1]": props.value === props.modelValue,
        },

        // Transition
        "transition duration-200",
      ],
    };
  },
};
